// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__11Fhn","addWidgetButton":"Header_addWidgetButton__2n6jK","dashboardTabs":"Header_dashboardTabs__1q2Tr","active":"Header_active__3B_kx"};